import { getResources } from '~/redux/api/ApiTypes';
import { UserAttributes } from '~/redux/api/methods/roles/roles';
import { rolodex } from '~/services/serviceInstances';

// TODO: We should point to rolodex types from spec file once it has been updated.
interface RolodexUserAttributes extends UserAttributes {
  user_management: string;
}

export const fetchUser: getResources<
  'user',
  RolodexUserAttributes
> = async () => {
  return rolodex.get('/user/self');
};
